module.exports = __webpack_public_path__ + "img/lg_ring_g_l_1_1@3x.f6557616.png";